/* ============================================================
   TEMPO — Shop: product data, the Baggie, checkout handoff
   ------------------------------------------------------------
   The bag lives in localStorage. Checkout hands off to Shopify's
   real cart permalink, so payment is processed by Shopify
   (cards / Shop Pay / Apple Pay / Google Pay — whatever is
   enabled in the store admin). No card data ever touches this
   site. Accounts likewise use Shopify's real customer accounts.
   ============================================================ */
(() => {
  'use strict';

  const SHOP = 'https://tempobpm.com';
  const STORAGE_KEY = 'tempo_baggie_v1';

  /* ---- catalog ----
     On Shopify this is only the fallback: layout/theme.liquid emits every
     product published to the Online Store as window.TEMPO_PRODUCTS, and
     buildCatalog() below prefers it, so activating a product in admin puts
     it on the store with no code change. This array is what the standalone
     site runs on, and what the live feed borrows size charts from. */
  const FALLBACK_PRODUCTS = [
    {
      id: 'waveform-tee', handle: 'waveform-oversized-t-shirt', cat: 'tee',
      title: '"WAVEFORM" Oversized T-Shirt', price: 75,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 }, { name:'Dark Gray', hex:'#3A3A40', img:2 } ],
      featured: true,
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/5b0e15d458ab48aea1ab2b2c6f0692ff.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/7b747901e144441cb590d2a052cc68c1.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/f48bd1b091f34467a36f9e9776ce004b.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/91445e74191343da88a0a23bffd543e5.png'
      ],
      alt: 'TEMPO WAVEFORM oversized black t-shirt with chrome star emblem on the back',
      desc: 'Center Piece of the TEMPO 150 Drop. "WAVEFORM". Star is soul.',
      sizeChart: {
        sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
        rows: [
          { label: 'Chest', inch: ['28.0', '28.7', '29.9', '31.5', '33.5', '35.4'], cm: ['71', '73', '76', '80', '85', '90'] },
          { label: 'Sleeve Length', inch: ['17.7', '18.1', '18.5', '18.9', '19.3', '19.7'], cm: ['45', '46', '47', '48', '49', '50'] },
          { label: 'Length', inch: ['25.2', '26.0', '26.8', '27.6', '28.3', '29.1'], cm: ['64', '66', '68', '70', '72', '74'] }
        ]
      },
      variants: {
        'Black':     { XS:'47468328812722', S:'47468328845490', M:'47468328878258', L:'47468328911026', XL:'47468328943794', '2XL':'47468328976562' },
        'Dark Gray': { XS:'47468329009330', S:'47468329042098', M:'47468329074866', L:'47468329107634', XL:'47468329140402', '2XL':'47468329173170' }
      }
    },
    {
      id: 'waveform-crop', handle: 'waveform-crop-tank-top', cat: 'tank',
      title: '"WAVEFORM" Crop Tank Top', price: 35,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 }, { name:'White', hex:'#F2F2F4', img:2 } ],
      featured: true,
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/742f7ae2c293452888f0e801965d4aae.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/1d69728cdbfa4767b31bd043fe54de13.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/74a97af44d2d42e29c32fb570185e980.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/028876f687df469cbe04a2bf4149c032.png'
      ],
      alt: 'WAVEFORM crop tank top, black',
      sizeChart: {
        sizes: ['S', 'M', 'L', 'XL'],
        rows: [
          { label: 'Chest', inch: ['13.4', '14.2', '15.4', '16.1'], cm: ['34', '36', '39', '41'] },
          { label: 'Length', inch: ['14.2', '14.6', '15.2', '15.7'], cm: ['36', '37', '38.5', '40'] },
          { label: 'Shoulder', inch: ['10.2', '10.6', '11.0', '11.4'], cm: ['26', '27', '28', '29'] }
        ]
      },
      variants: {
        'Black': { S:'47468368494770', M:'47468368527538', L:'47468368560306', XL:'47468368593074' },
        'White': { S:'47468368625842', M:'47468368658610', L:'47468368691378', XL:'47468368724146' }
      }
    },
    {
      id: 't3mpo-net', handle: 't3mpo-boxy-net-t-shirt', cat: 'tee',
      title: '"T3MPO" Boxy Net T-Shirt', price: 75,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 } ],
      featured: true,
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/6ee9f9c5c0a646b1a1b6b08095f3d694.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/08bf0a5c291a4b88b6a2eabd81277ee3.png'
      ],
      alt: 'T3MPO boxy net t-shirt, black mesh',
      sizeChart: {
        sizes: ['S', 'M', 'L', 'XL'],
        rows: [
          { label: 'Length', inch: ['24.80', '25.59', '26.38', '27.17'], cm: ['63', '65', '67', '69'] },
          { label: 'Shoulder', inch: ['19.69', '20.47', '21.26', '22.05'], cm: ['50', '52', '54', '56'] },
          { label: 'Chest', inch: ['23.62', '24.41', '25.20', '25.98'], cm: ['60', '62', '64', '66'] },
          { label: 'Sleeve length', inch: ['8.66', '9.06', '9.45', '9.84'], cm: ['22', '23', '24', '25'] }
        ]
      },
      variants: {
        'Black': { S:'47872762183858', M:'47872762216626', L:'47872762249394', XL:'47872762282162' }
      }
    },
    {
      id: 'brooklyn-tee', handle: 'brooklyn-tempo-t-shirt', cat: 'tee',
      title: '"Brooklyn TEMPO" T-Shirt', price: 50,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 }, { name:'Dusk Black', hex:'#24242B', img:2 } ],
      /* unfeatured so the homepage grid is exactly one row of three; it was
         the fourth card, left alone on a second row. Still in the catalogue
         and still on the store page. */
      featured: false,
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/d0b59a6e778545d0876f3acf400e6e5f.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/63bc71c36f0f4339821a08e62baeb066.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/0d0694f35c584bc7875ed2f8de70ea6b.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/f00faf98aa0f449f99e2510beef32c0f.png'
      ],
      alt: 'Brooklyn TEMPO t-shirt, black',
      desc: 'Brooklyn is where the heart of dance music lies.',
      sizeChart: {
        sizes: ['S', 'M', 'L', 'XL', '2XL'],
        rows: [
          { label: 'Chest', inch: ['21.7', '22.4', '23.2', '24.0', '24.8'], cm: ['55', '57', '59', '61', '63'] },
          { label: 'Length', inch: ['27.2', '28.0', '28.7', '30.3', '31.1'], cm: ['69', '71', '73', '77', '79'] },
          { label: 'Sleeve length', inch: ['14.2', '15.0', '15.7', '16.5', '17.3'], cm: ['36', '38', '40', '42', '44'] }
        ]
      },
      variants: {
        'Black':      { S:'47468383010994', M:'47468383043762', L:'47468383076530', XL:'47468383109298', '2XL':'47468383142066' },
        'Dusk Black': { S:'47468383174834', M:'47468383207602', L:'47468383240370', XL:'47468383273138', '2XL':'47468383305906' }
      }
    },
    {
      id: 'wave-boxy', handle: 'wave-oversized-boxy-t-shirt', cat: 'tee',
      title: 'WAVE Oversized Boxy T-Shirt', price: 65,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 }, { name:'Dark Gray', hex:'#3A3A40', img:2 } ],
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/76c9bac395be46e9926339012d2b4320.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/91d6d7fb98d045f293ef7abbdb7c0116.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/b25cee45f2da4868bfedc7221c2a0416.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/eb4e9efc71a345aab6c759ac6e3f3574.png'
      ],
      alt: 'WAVE oversized boxy t-shirt, black',
      desc: 'Just the WAVE. Oversize Premium Shirt.',
      sizeChart: {
        sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
        rows: [
          { label: 'Chest', inch: ['28.0', '28.7', '29.9', '31.5', '33.5', '35.4'], cm: ['71', '73', '76', '80', '85', '90'] },
          { label: 'Sleeve Length', inch: ['17.7', '18.1', '18.5', '18.9', '19.3', '19.7'], cm: ['45', '46', '47', '48', '49', '50'] },
          { label: 'Length', inch: ['25.2', '26.0', '26.8', '27.6', '28.3', '29.1'], cm: ['64', '66', '68', '70', '72', '74'] }
        ]
      },
      variants: {
        'Black':     { XS:'47468312658098', S:'47468312690866', M:'47468312723634', L:'47468312756402', XL:'47468312789170', '2XL':'47468312821938' },
        'Dark Gray': { XS:'47468312854706', S:'47468312887474', M:'47468312920242', L:'47468312953010', XL:'47468312985778', '2XL':'47468313018546' }
      }
    },
    {
      id: 'boxy-net', handle: 'boxy-net-t-shirt', cat: 'tee',
      title: 'Boxy Net T-Shirt', price: 70,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 } ],
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/af5471264dae4f1999b0bfda3a71eb46.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/2526e052d0774ee6bec8523570cd7391.png'
      ],
      alt: 'Boxy net t-shirt, black mesh',
      sizeChart: {
        sizes: ['S', 'M', 'L', 'XL'],
        rows: [
          { label: 'Length', inch: ['24.80', '25.59', '26.38', '27.17'], cm: ['63', '65', '67', '69'] },
          { label: 'Shoulder', inch: ['19.69', '20.47', '21.26', '22.05'], cm: ['50', '52', '54', '56'] },
          { label: 'Chest', inch: ['23.62', '24.41', '25.20', '25.98'], cm: ['60', '62', '64', '66'] },
          { label: 'Sleeve length', inch: ['8.66', '9.06', '9.45', '9.84'], cm: ['22', '23', '24', '25'] }
        ]
      },
      variants: {
        'Black': { S:'47872762970290', M:'47872763003058', L:'47872763035826', XL:'47872763068594' }
      }
    },
    {
      id: 'waveform-tank', handle: 'wave-form-tank-top', cat: 'tank',
      title: '"WAVE-FORM" Tank Top', price: 50,
      /* Shopify lists Light Gray first, but images[0] is the black shot and the
         gallery leads with it — so Black is the default here and the order
         below follows the gallery, not the admin. */
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 }, { name:'Dark Gray', hex:'#3A3A40', img:2 }, { name:'Light Gray', hex:'#C9C9CF', img:4 } ],
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/ef43ca3a4e57452783eb4db42f2a9d54.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/452816b706ad465796df3a318fb02f58.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/8760b64c63c44a53baae6bd8c734f1e4.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/53284211458a486380fecbf6836e6820.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/ec3b565c05b848a7a4b6ce21dabbc773.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/1847411a70504455922b3112fd149a30.png'
      ],
      alt: 'WAVE-FORM tank top, black',
      variants: {
        'Black':      { S:'47872761397426', M:'47872761430194', L:'47872761462962', XL:'47872761495730', '2XL':'47872761528498' },
        'Dark Gray':  { S:'47872761561266', M:'47872761594034', L:'47872761626802', XL:'47872761659570', '2XL':'47872761692338' },
        'Light Gray': { S:'47872761233586', M:'47872761266354', L:'47872761299122', XL:'47872761331890', '2XL':'47872761364658' }
      }
    },
    {
      id: 'wave-crop', handle: 'wave-crop-tank-top', cat: 'tank',
      title: 'Wave Crop Tank Top', price: 35,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 } ],
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/52e002acb6c6430d8865c2b3d3afcf4c.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/03d36a49a0df441689e480736dcd6c02.png'
      ],
      alt: 'Small WAVE logo crop tank top, black',
      desc: 'Small Wave logo crop top. Represent Tempo',
      sizeChart: {
        sizes: ['S', 'M', 'L', 'XL'],
        rows: [
          { label: 'Chest', inch: ['13.4', '14.2', '15.4', '16.1'], cm: ['34', '36', '39', '41'] },
          { label: 'Length', inch: ['14.2', '14.6', '15.2', '15.7'], cm: ['36', '37', '38.5', '40'] },
          { label: 'Shoulder', inch: ['10.2', '10.6', '11.0', '11.4'], cm: ['26', '27', '28', '29'] }
        ]
      },
      variants: {
        'Black': { S:'47468296962226', M:'47468296994994', L:'47468297027762', XL:'47468297060530' }
      }
    },
    {
      id: 'feral-crop', handle: 'feral-puta-crop-tank-top', cat: 'tank',
      title: '"Feral Puta" Crop Tank Top', price: 35,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 } ],
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/437e66d294014c749c54ffb4837286fd.png',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/65393d82c3114e9789da8b3ed3af4888.png'
      ],
      alt: 'Feral Puta crop tank top, black',
      desc: 'We are taking Puta back. Express your inner Feral Puta!',
      sizeChart: {
        sizes: ['S', 'M', 'L', 'XL'],
        rows: [
          { label: 'Chest', inch: ['13.4', '14.2', '15.4', '16.1'], cm: ['34', '36', '39', '41'] },
          { label: 'Length', inch: ['14.2', '14.6', '15.2', '15.7'], cm: ['36', '37', '38.5', '40'] },
          { label: 'Shoulder', inch: ['10.2', '10.6', '11.0', '11.4'], cm: ['26', '27', '28', '29'] }
        ]
      },
      variants: {
        'Black': { S:'47468301615282', M:'47468301648050', L:'47468301680818', XL:'47468301713586' }
      }
    },
    /* ---- caps ----
       cat 'cap' is new. The store filter is an "All" chip only right now, so
       nothing has to be added there; data-category just rides along until the
       catalogue is big enough to want chips again. One size, so no sizeChart —
       the PDP prints its "no chart published" note instead. */
    {
      id: 'wave-cap', handle: 'wave-cap', cat: 'cap',
      title: 'Wave Cap', price: 34.99,
      colors: [ { name:'Black', hex:'#0B0B0D', img:0 } ],
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/3958758636970615770_2048.jpg',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/11905944629486017792_2048.jpg',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/17590449738938488204_2048.jpg',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/5852369530473773717_2048.jpg'
      ],
      alt: 'TEMPO Wave cap in black, wave mark embroidered on the front',
      variants: {
        'Black': { 'One size':'48042101440690' }
      }
    },
    {
      id: 'feral-cap', handle: 'feral-puta-cap', cat: 'cap',
      title: '"Feral Puta" Cap', price: 34.99,
      /* White first: it is the shop's featured image and so images[0]. */
      colors: [ { name:'White', hex:'#F2F2F4', img:0 }, { name:'Black', hex:'#0B0B0D', img:1 } ],
      images: [
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/1414752126954662647_2048.jpg',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/301982235307013852_2048.jpg',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/890087199443648505_2048.jpg',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/4127667416212051719_2048.jpg',
        'https://cdn.shopify.com/s/files/1/0723/5285/8290/files/3982721767498824741_2048.jpg'
      ],
      alt: 'TEMPO Feral Puta cap, white with red lettering',
      desc: 'Feral Puta Cap.',
      variants: {
        'White': { 'One size':'48042104455346' },
        'Black': { 'One size':'48042104422578' }
      }
    }
  ];

  /* Shopify stores a colour's *name*, never a swatch colour, so the hex has to
     live here. An unknown name falls back to a mid grey rather than vanishing
     against the page — a missing swatch would read as a broken chip. */
  /* Keep in step with snippets/tempo-colour-hex.liquid, which is the same
     table for the Shopify product page. Anything missing here renders a mid
     grey dot, so a colourway added in admin shows a chip that says nothing —
     which is what Brown, Light Purple, Baby Pink and the two-tone caps did
     until this was filled in. */
  const COLOR_HEX = {
    'Black': '#0B0B0D', 'Dusk Black': '#24242B', 'Dark Gray': '#3A3A40',
    'Dark Grey': '#3A3A40', 'Light Gray': '#C9C9CF', 'Light Grey': '#C9C9CF',
    'White': '#F2F2F4', 'Red': '#B3121D', 'Bone': '#E6E2D8',
    'Brown': '#5A4436', 'Light Purple': '#B9A7D9', 'Baby Pink': '#F2C9D4',
    'Charcoal': '#2E2E34', 'Black / Charcoal': '#2E2E34', 'Black / White': '#1A1A1F'
  };

  /* The live feed knows everything Shopify knows — title, price, images,
     colourways, variant ids — and nothing it does not. Size charts are
     hand-measured, so they are carried over from the local entry with the same
     handle, along with the id, which keeps saved baggies valid: a line stored
     against 'waveform-tee' would be dropped if that product came back from
     Shopify keyed only by its handle. */
  function buildCatalog() {
    const live = window.TEMPO_PRODUCTS;
    if (!Array.isArray(live) || !live.length) return FALLBACK_PRODUCTS;

    const local = {};
    FALLBACK_PRODUCTS.forEach((p) => { local[p.handle] = p; });

    const out = live.map((p) => {
      const l = local[p.handle] || {};
      return Object.assign({}, p, {
        id: l.id || p.handle,
        alt: p.alt || l.alt || p.title,
        desc: p.desc || l.desc || '',
        sizeChart: l.sizeChart,
        colors: (p.colors || []).map((c) =>
          Object.assign({}, c, { hex: COLOR_HEX[c.name] || '#3A3A40' }))
      });
    }).filter((p) => p.colors.length && Object.keys(p.variants || {}).length);

    /* Nothing in Shopify says "featured" unless a product is tagged for it.
       Rather than ship an empty home grid the day the feed goes live, the
       first three stand in until a tag exists. */
    if (!out.some((p) => p.featured)) out.slice(0, 3).forEach((p) => { p.featured = true; });
    return out;
  }

  const PRODUCTS = buildCatalog();

  /* ---- HOT sticker: doubles as the favourite toggle ---- */
  const HOT_SVG = `<svg viewBox="0 0 124 108" aria-hidden="true" focusable="false">
      <path class="sticker__shape" d="M6,94 L6,52 Q6,29 21,8 Q25,1 28,12 L34,31 Q36,37 39,31
        L45,17 Q48,9 51,18 L56,33 Q58,39 61,32 L69,6 Q73,-1 76,7 L84,32 Q86,38 89,32
        L94,19 Q97,11 100,20 L105,34 Q107,40 110,33 L115,15 Q119,26 119,45 L119,94
        Q119,101 112,101 L13,101 Q6,101 6,94 Z"/>
      <text class="sticker__text" x="62" y="82" text-anchor="middle">HOT</text>
    </svg>`;

  const FAV_KEY = 'tempo_favs_v1';
  let favs = new Set();
  try {
    const raw = localStorage.getItem(FAV_KEY);
    if (raw) favs = new Set(JSON.parse(raw));
  } catch (_) {}
  const persistFavs = () => {
    try { localStorage.setItem(FAV_KEY, JSON.stringify([...favs])); } catch (_) {}
  };

  const CAT_LABEL = { tee: 'Tee', tank: 'Tank', cap: 'Cap', fan: 'Fan' };
  const byId = (id) => PRODUCTS.find((p) => p.id === id);
  /* Colour is a real Shopify option on every one of these products — the site
     just never exposed it. Each entry carries the swatch hex and the index of
     its own shot in `images`, so choosing a colour can move the gallery to the
     garment you actually picked. First entry is the default. */
  const defaultColor = (p) => p.colors[0].name;
  const colorMeta = (p, name) => p.colors.find((c) => c.name === name) || p.colors[0];
  const hasColor = (p, name) => !!(name && p.variants[name]);
  const okColor = (p, name) => (hasColor(p, name) ? name : defaultColor(p));
  const sizesFor = (p, color) => Object.keys(p.variants[okColor(p, color)]);
  const variantId = (p, color, size) => (p.variants[okColor(p, color)] || {})[size];
  const colorLabel = (p) => (p.colors.length > 1
    ? `${p.colors[0].name} +${p.colors.length - 1}`
    : p.colors[0].name);
  /* A run of sizes reads as a range; a single size reads as itself. Without
     this the caps advertised themselves as "One size–One size". */
  const sizeRange = (sizes) => (sizes.length > 1
    ? `${sizes[0]}–${sizes[sizes.length - 1]}`
    : sizes[0]);
  /* "M" wants the word in front of it, "One size" already has it. */
  const sizeLabel = (size) => (/size/i.test(size) ? size : `Size ${size}`);
  const heroImg = (p) => p.images[0];
  /* The standalone site serves the detail page at product.html. The theme
     sends shoppers to Shopify's own product page instead, at
     /products/<handle>. That page is the only place a real Apple Pay or
     Shop Pay button can exist — Shopify builds the wallet sheet against a
     payment session for a specific variant, which a Page template has no
     way to produce. It is also live data, so prices and stock cannot drift.
     /pages/product still renders for anyone holding an old link. */
  const productUrl = (p) => `/products/${encodeURIComponent(p.handle || p.id)}`;
  const productAbsUrl = (p) => new URL(productUrl(p), SHOP.replace(/\/$/, '') + '/').href;
  const money = (n) => '$' + n.toFixed(2).replace(/\.00$/, '');
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

  /* ---- where the bag is kept ----
     On the standalone site the bag is a localStorage array and Shopify only
     hears about it at checkout, as one long cart permalink. The theme sets
     window.TEMPO_SHOPIFY_CART, and then Shopify's own cart IS the bag.

     That matters for wallets. Apple Pay and Shop Pay can only exist on a real
     product page, and that page posts to Shopify's cart — so with two carts a
     shopper could add three things to the drawer, hit Apple Pay, and buy only
     the one piece Shopify knew about. One cart is what makes the express
     buttons safe to show.

     The adapter lives here rather than in the layout because it needs the
     catalogue to turn a variant id back into {product, colour, size}. Both
     paths resolve through the same callers, so nothing downstream changes. */
  const USE_SHOPIFY_CART = typeof window !== 'undefined' && !!window.TEMPO_SHOPIFY_CART;

  let variantLookup = null;
  function byVariant(vid) {
    if (!variantLookup) {
      variantLookup = {};
      PRODUCTS.forEach((p) => {
        Object.keys(p.variants || {}).forEach((color) => {
          Object.keys(p.variants[color]).forEach((size) => {
            variantLookup[String(p.variants[color][size])] = { id: p.id, color, size };
          });
        });
      });
    }
    return variantLookup[String(vid)] || null;
  }

  const cartAjax = (url, body) => fetch(url, {
    method: body ? 'POST' : 'GET',
    headers: body
      ? { 'Content-Type': 'application/json', Accept: 'application/json' }
      : { Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin'
  }).then((r) => r.json());

  const SHOPIFY_CART = {
    /* A line Shopify holds that this catalogue does not recognise is skipped
       rather than rendered: the drawer prices every line from PRODUCTS, so a
       stranger would throw. It stays in Shopify's cart and still checks out. */
    load: () => cartAjax('/cart.js').then((c) => (c.items || []).map((it) => {
      const m = byVariant(it.variant_id);
      return m ? { id: m.id, size: m.size, color: m.color, qty: it.quantity } : null;
    }).filter(Boolean)),
    add: (vid, qty) => cartAjax('/cart/add.js', { items: [{ id: Number(vid), quantity: qty }] }),
    setQty: (vid, qty) => cartAjax('/cart/change.js', { id: String(vid), quantity: qty })
  };

  function refreshFromShopify() {
    return SHOPIFY_CART.load()
      .then((lines) => { bag = lines; render(); })
      .catch(() => {});
  }

  /* ---- bag state ---- */
  let bag = [];
  try {
    // With Shopify's cart in play the bag is fetched below, not read from here.
    const raw = USE_SHOPIFY_CART ? null : localStorage.getItem(STORAGE_KEY);
    /* Lines saved before colour existed have no `color`; they were all the
       default colourway, so they are adopted rather than dropped. A line whose
       colour or size no longer maps to a variant is dropped, same as before. */
    if (raw) bag = JSON.parse(raw).map((l) => {
      const p = byId(l.id);
      if (!p) return null;
      const color = okColor(p, l.color);
      if (!variantId(p, color, l.size)) return null;
      return { id: l.id, size: l.size, color, qty: l.qty };
    }).filter(Boolean);
  } catch (_) { bag = []; }

  const persist = () => {
    if (USE_SHOPIFY_CART) return;   // Shopify's cart is the store; nothing to mirror
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(bag)); } catch (_) {}
  };
  const count = () => bag.reduce((n, l) => n + l.qty, 0);
  const subtotal = () => bag.reduce((n, l) => n + byId(l.id).price * l.qty, 0);
  // a line is a colourway in a size — black M and white M are two lines
  const lineIndex = (id, size, color) =>
    bag.findIndex((l) => l.id === id && l.size === size && l.color === color);

  function addToBag(id, size, color, qty = 1) {
    const c = okColor(byId(id), color);
    if (USE_SHOPIFY_CART) {
      const vid = variantId(byId(id), c, size);
      if (vid) SHOPIFY_CART.add(vid, Math.min(qty, 99)).then(refreshFromShopify);
      return;
    }
    const i = lineIndex(id, size, c);
    if (i > -1) bag[i].qty = Math.min(bag[i].qty + qty, 99);
    else bag.push({ id, size, color: c, qty: Math.min(qty, 99) });
    persist(); render();
  }
  function setQty(id, size, color, qty) {
    if (USE_SHOPIFY_CART) {
      const vid = variantId(byId(id), color, size);
      if (vid) SHOPIFY_CART.setQty(vid, Math.max(0, Math.min(qty, 99))).then(refreshFromShopify);
      return;
    }
    const i = lineIndex(id, size, color);
    if (i < 0) return;
    if (qty <= 0) bag.splice(i, 1);
    else bag[i].qty = Math.min(qty, 99);
    persist(); render();
  }

  /* Shopify cart permalink — real cart, real checkout, real payment */
  function checkoutUrl() {
    if (!bag.length) return null;
    // Shopify already holds the cart, so checkout is just checkout — no permalink.
    if (USE_SHOPIFY_CART) return '/checkout';
    const parts = bag.map((l) => `${variantId(byId(l.id), l.color, l.size)}:${l.qty}`);
    return `${SHOP}/cart/${parts.join(',')}`;
  }

  /* ---- product grid rendering ---- */
  function cardHTML(p) {
    // The card adds the default colourway; picking a colour is the PDP's job,
    // so the spec line only has to say that a choice exists.
    const sizes = sizesFor(p, defaultColor(p));
    const url = productUrl(p);
    return `
<article class="card" data-category="${p.cat}" data-new="${p.featured ? '1' : '0'}" data-product="${p.id}">
  <div class="card__mediawrap">
    <a class="card__media ratio-1-1" href="${url}" tabindex="-1" aria-hidden="true">
      ${p.badge ? `<span class="card__badge">${esc(p.badge)}</span>` : ''}
      <img src="${heroImg(p)}" alt="" loading="lazy" width="800" height="800">
      ${p.images.length > 1 ? `<img class="card__alt" src="${p.images[1]}" alt="" loading="lazy" decoding="async" width="800" height="800">` : ''}
    </a>
    <button type="button" class="sticker" data-fav="${p.id}"
            aria-pressed="${favs.has(p.id) ? 'true' : 'false'}"
            aria-label="Save ${esc(p.title)} to favourites">${HOT_SVG}</button>
  </div>
  <div class="card__caption">
    <div class="card__meta">
      <a class="card__title" href="${url}">${esc(p.title)}</a>
      <span class="card__price">${money(p.price)}</span>
    </div>
    <span class="card__spec">${esc(colorLabel(p))} &middot; ${sizeRange(sizes)}</span>
  </div>
  <div class="card__body">
    <div class="card__foot">
      <div class="size-row" role="group" aria-label="Select size for ${esc(p.title)}">
        ${sizes.map((s) => `<button type="button" class="size-chip" data-size="${s}" aria-pressed="false">${s}</button>`).join('')}
      </div>
      <p class="size-hint" role="status"></p>
      <button type="button" class="btn btn-chrome btn-block card__add">Add to Baggie</button>
    </div>
  </div>
</article>`;
  }

  function renderGrids() {
    document.querySelectorAll('[data-product-grid]').forEach((grid) => {
      const which = grid.dataset.productGrid;
      const list = which === 'featured' ? PRODUCTS.filter((p) => p.featured) : PRODUCTS;
      grid.innerHTML = list.map((p) => cardHTML(p)).join('');
    });
  }

  /* ---- favourites panel (My TEMPO) ----
     Favourites still live under their own key so the HOT sticker works the
     same on every page — this just surfaces them as part of the profile,
     which is what "save to the profile" means with no backend yet. */
  function favouriteLineHTML(p) {
    const url = productUrl(p);
    return `
<li class="bag-line" data-fav-line="${p.id}">
  <div class="bag-line__media"><a href="${url}"><img src="${heroImg(p)}" alt="" loading="lazy"></a></div>
  <div class="bag-line__info">
    <a class="bag-line__title" href="${url}">${esc(p.title)}</a>
    <p class="bag-line__spec">${esc(colorLabel(p))} · ${money(p.price)}</p>
  </div>
  <div class="bag-line__end">
    <button type="button" class="bag-line__remove" data-fav="${p.id}" aria-label="Remove ${esc(p.title)} from favourites">Remove</button>
  </div>
</li>`;
  }

  function renderFavourites() {
    const list = document.querySelector('[data-favorites-list]');
    if (!list) return;
    const items = [...favs].map(byId).filter(Boolean);
    list.innerHTML = items.map(favouriteLineHTML).join('');
    const empty = document.querySelector('[data-favorites-empty]');
    if (empty) empty.hidden = items.length > 0;
    const countEl = document.querySelector('[data-fav-count]');
    if (countEl) {
      countEl.innerHTML = `<b>${items.length}</b> saved`;
      // nothing to count when there is nothing saved; the empty note below
      // is an instruction, not a tally, so it does not state the zero either
      countEl.hidden = items.length === 0;
    }
  }

  /* ---- product detail page (product.html?id=…) ----
     Copy here is only ever the product's own Shopify description, its real
     measurement chart and its real policy links — nothing about the garment
     is invented on this side. */
  let pdpQty = 1;
  // The colourway currently being looked at, and the size chosen within it.
  // Size is kept across a colour change when the new colourway also has it.
  let pdpColor = '';
  let pdpSize = '';
  /* p.alt describes the default colourway. For any other one, say which colour
     is actually in the frame rather than repeating the black shirt's alt. */
  const heroAlt = (p) =>
    (pdpColor === defaultColor(p) ? p.alt : `${p.title} — ${pdpColor}`);

  /* The gallery leads with the chosen colourway and then shows the other
     angles. The colourway shots of the *other* colours are held back: they are
     reachable by picking that colour, and left in the list they read as extra
     views of the garment you are looking at. That is what the page did before
     colour existed — the third shot of the WAVEFORM tee is the Dark Gray one,
     shown as "view 3" of the black shirt. */
  function galleryHTML(p) {
    const heroIdx = colorMeta(p, pdpColor).img;
    const otherHeroes = new Set(p.colors.map((c) => c.img).filter((i) => i !== heroIdx));
    const rest = p.images
      .map((src, i) => ({ src, i }))
      .filter((x) => x.i !== heroIdx && !otherHeroes.has(x.i));

    const hero = `
<div class="pdp__shot card__mediawrap">
  <img data-pdp-hero src="${p.images[heroIdx]}" alt="${esc(heroAlt(p))}" width="800" height="800">
  <button type="button" class="sticker" data-fav="${p.id}"
          aria-pressed="${favs.has(p.id) ? 'true' : 'false'}"
          aria-label="Save ${esc(p.title)} to favourites">${HOT_SVG}</button>
</div>`;

    return hero + rest.map((x, n) => `
<div class="pdp__shot">
  <img src="${x.src}" alt="${esc(p.title)} — view ${n + 2}" loading="lazy" width="800" height="800">
</div>`).join('');
  }

  function sizeChartHTML(p) {
    if (!p.sizeChart) {
      return `<p class="pdp__note">No measurement chart is published for this piece yet.
        If you need exact measurements before you order,
        <a href="${SHOP}/policies/contact-information" target="_blank" rel="noopener">get in touch</a>.</p>`;
    }
    const { sizes, rows } = p.sizeChart;
    return `
<div class="pdp__tablewrap">
  <table class="pdp__table">
    <thead>
      <tr><th scope="col">Measurement</th>${sizes.map((s) => `<th scope="col">${esc(s)}</th>`).join('')}</tr>
    </thead>
    <tbody>
      ${rows.map((r) => `<tr>
        <th scope="row">${esc(r.label)}</th>
        ${r.inch.map((v, i) => `<td>${esc(v)}<span class="pdp__cm">${esc(r.cm[i])} cm</span></td>`).join('')}
      </tr>`).join('')}
    </tbody>
  </table>
</div>
<p class="pdp__note">Inches on top, centimetres underneath.</p>`;
  }

  function pdpInfoHTML(p) {
    const sizes = sizesFor(p, pdpColor);
    return `
<p class="eyebrow">${CAT_LABEL[p.cat] || 'Tee'}${p.featured ? ' — new' : ''}</p>
<h1 class="display pdp__title">${esc(p.title)}</h1>
<p class="pdp__price">${money(p.price)}</p>
${p.desc ? `<p class="pdp__desc">${esc(p.desc)}</p>` : ''}
${p.colors.length > 1 ? `
<div class="pdp__block">
  <div class="pdp__blockhead">
    <span class="spec">Colour</span>
  </div>
  <div class="colour-row" role="group" aria-label="Select colour for ${esc(p.title)}">
    ${p.colors.map((c) => `<button type="button" class="colour-chip" data-colour="${esc(c.name)}"
        aria-pressed="${c.name === pdpColor ? 'true' : 'false'}" title="${esc(c.name)}">
      <span class="colour-chip__dot" style="--swatch:${c.hex}"></span>
      <span class="colour-chip__name">${esc(c.name)}</span>
    </button>`).join('')}
  </div>
</div>` : `<p class="spec pdp__colour">Colour &middot; ${esc(pdpColor)}</p>`}

<div class="pdp__block">
  <div class="pdp__blockhead">
    <span class="spec">Size</span>
    <button type="button" class="pdp__sizelink" data-pdp-sizeguide>Size guide</button>
  </div>
  <div class="size-row" role="group" aria-label="Select size for ${esc(p.title)}">
    ${sizes.map((s) => `<button type="button" class="size-chip" data-size="${s}" aria-pressed="${s === pdpSize ? 'true' : 'false'}">${s}</button>`).join('')}
  </div>
  <p class="size-hint" role="status"></p>
</div>

<div class="pdp__block">
  <span class="spec">Quantity</span>
  <div class="qty qty--pdp" role="group" aria-label="Quantity">
    <button type="button" class="qty__btn" data-pdp-qty="dec" aria-label="Decrease quantity">&minus;</button>
    <span class="qty__n" data-pdp-qtyn aria-live="polite">1</span>
    <button type="button" class="qty__btn" data-pdp-qty="inc" aria-label="Increase quantity">+</button>
  </div>
</div>

<button type="button" class="btn btn-chrome btn-block pdp__add">Add to Baggie</button>
<p class="pdp__note">Card, Shop Pay, Apple Pay and Google Pay are all accepted at checkout.</p>

<details class="pdp__acc" open>
  <summary>Product details</summary>
  <div class="pdp__accbody">
    <dl class="pdp__dl">
      <div><dt>${p.colors.length > 1 ? 'Colours' : 'Colour'}</dt><dd>${p.colors.map((c) => esc(c.name)).join(' &middot; ')}</dd></div>
      <div><dt>${sizes.length > 1 ? 'Sizes' : 'Size'}</dt><dd data-pdp-sizesdd>${sizes.join(' · ')}</dd></div>
    </dl>
  </div>
</details>

<details class="pdp__acc" data-pdp-guide>
  <summary>Size guide</summary>
  <div class="pdp__accbody">${sizeChartHTML(p)}</div>
</details>

<details class="pdp__acc">
  <summary>Shipping &amp; returns</summary>
  <div class="pdp__accbody">
    <p>Shipping options and delivery estimates are shown at checkout, once you have entered an address.</p>
    <p>Returns and refunds are covered by our
      <a href="${SHOP}/policies/refund-policy" target="_blank" rel="noopener">refund policy</a>.
      Anything else, <a href="${SHOP}/policies/contact-information" target="_blank" rel="noopener">get in touch</a>.</p>
  </div>
</details>`;
  }

  function renderPDP() {
    const wrap = document.querySelector('[data-pdp]');
    if (!wrap) return;

    const id = new URLSearchParams(location.search).get('id');
    const p = id ? byId(id) : null;
    const missing = document.querySelector('[data-pdp-missing]');
    if (p && !hasColor(p, pdpColor)) pdpColor = defaultColor(p);

    if (!p) {
      wrap.hidden = true;
      if (missing) missing.hidden = false;
      document.title = 'Piece not found — TEMPO';
      return;
    }

    wrap.hidden = false;
    if (missing) missing.hidden = true;

    pdpColor = okColor(p, pdpColor);
    if (!sizesFor(p, pdpColor).includes(pdpSize)) pdpSize = '';

    document.querySelector('[data-pdp-media]').innerHTML = galleryHTML(p);
    document.querySelector('[data-pdp-info]').innerHTML = pdpInfoHTML(p);

    const crumb = document.querySelector('[data-pdp-crumb]');
    if (crumb) crumb.textContent = p.title;

    // related: same rack first, topped up from the rest of the line
    const sameCat = PRODUCTS.filter((x) => x.id !== p.id && x.cat === p.cat);
    const others = PRODUCTS.filter((x) => x.id !== p.id && x.cat !== p.cat);
    const related = [...sameCat, ...others].slice(0, 3);
    document.querySelector('[data-pdp-related]').innerHTML = related.map((x) => cardHTML(x)).join('');

    // page metadata follows the piece
    document.title = `${p.title} — TEMPO`;
    const desc = p.desc || `${p.title} — ${p.color}, ${money(p.price)}. From the TEMPO line.`;
    const set = (sel, attr, val) => {
      const el = document.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };
    set('link[rel="canonical"]', 'href', productAbsUrl(p));
    set('meta[name="description"]', 'content', desc);
    set('meta[property="og:url"]', 'content', productAbsUrl(p));
    set('meta[property="og:title"]', 'content', `${p.title} — TEMPO`);
    set('meta[property="og:description"]', 'content', desc);
    set('meta[property="og:image"]', 'content', heroImg(p));
    set('meta[property="og:image:alt"]', 'content', p.alt);
    set('meta[name="twitter:title"]', 'content', `${p.title} — TEMPO`);
    set('meta[name="twitter:description"]', 'content', desc);
    set('meta[name="twitter:image"]', 'content', heroImg(p));
    set('meta[name="twitter:image:alt"]', 'content', p.alt);
  }

  function setPdpQty(n) {
    pdpQty = Math.min(Math.max(n, 1), 99);
    const el = document.querySelector('[data-pdp-qtyn]');
    if (el) el.textContent = pdpQty;
  }

  /* ---- bag drawer rendering ---- */
  function lineHTML(l) {
    const p = byId(l.id);
    return `
<li class="bag-line" data-id="${p.id}" data-size="${esc(l.size)}" data-color="${esc(l.color)}">
  <div class="bag-line__media"><img src="${heroImg(p)}" alt="" loading="lazy"></div>
  <div class="bag-line__info">
    <p class="bag-line__title">${esc(p.title)}</p>
    <p class="bag-line__spec">${esc(l.color)} &middot; ${esc(sizeLabel(l.size))}</p>
    <div class="qty" role="group" aria-label="Quantity for ${esc(p.title)}, ${esc(l.color)}, ${esc(sizeLabel(l.size).toLowerCase())}">
      <button type="button" class="qty__btn" data-act="dec" aria-label="Decrease quantity">&minus;</button>
      <span class="qty__n" aria-live="polite">${l.qty}</span>
      <button type="button" class="qty__btn" data-act="inc" aria-label="Increase quantity">+</button>
    </div>
  </div>
  <div class="bag-line__end">
    <span class="bag-line__price">${money(p.price * l.qty)}</span>
    <button type="button" class="bag-line__remove" data-act="remove" aria-label="Remove ${esc(p.title)}, ${esc(l.color)}, ${esc(sizeLabel(l.size).toLowerCase())} from baggie">Remove</button>
  </div>
</li>`;
  }

  /* ---- checkout page ----
     Same lines as the drawer, same localStorage, same handoff. The drawer is a
     glance; this is the page you land on when you actually mean it, so it also
     carries the totals breakdown and says where the card details go.

     Both states ship hidden and are revealed here rather than in the markup:
     the bag is not known until localStorage has been read, and defaulting to
     the empty state would flash 'your baggie is empty' at people whose baggie
     is not. */
  function renderCheckout() {
    const wrap = document.querySelector('[data-checkout]');
    if (!wrap) return;

    const n = count();
    const empty = document.querySelector('[data-checkout-empty]');
    wrap.hidden = n === 0;
    if (empty) empty.hidden = n > 0;

    const body = document.querySelector('[data-checkout-body]');
    if (body) body.innerHTML = bag.map(lineHTML).join('');

    const c = document.querySelector('[data-checkout-count]');
    if (c) c.textContent = n === 1 ? '1 piece' : `${n} pieces`;

    const sum = money(subtotal());
    document.querySelectorAll('[data-checkout-subtotal], [data-checkout-total]')
      .forEach((el) => { el.textContent = sum; });
  }

  function render() {
    const n = count();

    document.querySelectorAll('[data-bag-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-bag-open]').forEach((el) => {
      el.setAttribute('aria-label', n ? `Baggie, ${n} item${n === 1 ? '' : 's'}` : 'Baggie, empty');
    });

    // querySelectorAll, not querySelector: the checkout page carries its own
    // handoff button, and on a page that has both only the first would be wired.
    document.querySelectorAll('[data-bag-checkout]').forEach((co) => {
      const url = checkoutUrl();
      if (url) { co.href = url; co.removeAttribute('aria-disabled'); }
      else { co.removeAttribute('href'); co.setAttribute('aria-disabled', 'true'); }
    });

    renderCheckout();

    const body = document.querySelector('[data-bag-body]');
    const empty = document.querySelector('[data-bag-empty]');
    const foot = document.querySelector('[data-bag-foot]');
    if (!body) return;

    body.innerHTML = bag.map(lineHTML).join('');
    if (empty) empty.hidden = n > 0;
    if (foot) foot.hidden = n === 0;

    const sub = document.querySelector('[data-bag-subtotal]');
    if (sub) sub.textContent = money(subtotal());
  }

  /* ---- drawer open/close ---- */
  const drawer = () => document.querySelector('[data-bag-drawer]');
  let lastFocus = null;

  function openBag() {
    const d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const close = d.querySelector('[data-bag-close]');
    if (close) close.focus();
  }
  function closeBag() {
    const d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---- toast ---- */
  let toastTimer;
  function toast(msg) {
    let t = document.querySelector('.toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---- events ---- */
  document.addEventListener('click', (e) => {
    // HOT sticker → favourite toggle
    const fav = e.target.closest('[data-fav]');
    if (fav) {
      e.preventDefault();
      const id = fav.dataset.fav;
      const now = !favs.has(id);
      if (now) favs.add(id); else favs.delete(id);
      persistFavs();
      // keep every copy of this product in sync (home + store + profile)
      document.querySelectorAll(`[data-fav="${CSS.escape(id)}"]`).forEach((el) => {
        el.setAttribute('aria-pressed', now ? 'true' : 'false');
      });
      renderFavourites();
      if (now) {
        fav.classList.remove('is-popping');
        void fav.offsetWidth;
        fav.classList.add('is-popping');
      }
      const prod = byId(id);
      toast(now ? `${prod.title} saved to your favourites` : `${prod.title} removed from favourites`);
      return;
    }

    // colour chips (detail page only)
    const swatch = e.target.closest('.colour-chip');
    if (swatch) {
      const id = new URLSearchParams(location.search).get('id');
      const p = byId(id);
      if (!p) return;
      const next = swatch.dataset.colour;
      if (next === pdpColor) return;
      pdpColor = okColor(p, next);

      const row = swatch.closest('.colour-row');
      row.querySelectorAll('.colour-chip').forEach((c) =>
        c.setAttribute('aria-pressed', c.dataset.colour === pdpColor ? 'true' : 'false'));
      /* Re-render the size row rather than just relabelling it: a colourway is
         free to stock a different run of sizes, and today's matrix being square
         is not something to bake in. A size already chosen survives if the new
         colourway has it. */
      if (!sizesFor(p, pdpColor).includes(pdpSize)) pdpSize = '';
      const sizeRow = document.querySelector('[data-pdp-info] .size-row');
      if (sizeRow) {
        sizeRow.innerHTML = sizesFor(p, pdpColor).map((sz) =>
          `<button type="button" class="size-chip" data-size="${sz}" aria-pressed="${sz === pdpSize ? 'true' : 'false'}">${sz}</button>`).join('');
      }
      const hint = document.querySelector('[data-pdp-info] .size-hint');
      if (hint) { hint.textContent = ''; hint.classList.remove('is-error'); }
      const sizesDd = document.querySelector('[data-pdp-sizesdd]');
      if (sizesDd) sizesDd.textContent = sizesFor(p, pdpColor).join(' · ');

      /* Swap the lead shot rather than scrolling to it. Moving the viewport on
         a swatch tap throws the shopper away from the picker they are using,
         and the size row they want next is directly under it. */
      const hero = document.querySelector('[data-pdp-hero]');
      if (hero) {
        hero.src = p.images[colorMeta(p, pdpColor).img];
        hero.alt = heroAlt(p);
      }
      return;
    }

    // size chips (product cards and the detail page share this)
    const chip = e.target.closest('.size-chip');
    if (chip) {
      const scope = chip.closest('.card, [data-pdp-info]');
      if (!scope) return;
      scope.querySelectorAll('.size-chip').forEach((c) => c.setAttribute('aria-pressed', 'false'));
      chip.setAttribute('aria-pressed', 'true');
      if (scope.matches('[data-pdp-info]')) pdpSize = chip.dataset.size;
      const hint = scope.querySelector('.size-hint');
      if (hint) { hint.textContent = ''; hint.classList.remove('is-error'); }
      return;
    }

    // detail page: quantity stepper
    const qtyBtn = e.target.closest('[data-pdp-qty]');
    if (qtyBtn) {
      setPdpQty(pdpQty + (qtyBtn.dataset.pdpQty === 'inc' ? 1 : -1));
      return;
    }

    // detail page: "Size guide" jumps to the chart accordion
    if (e.target.closest('[data-pdp-sizeguide]')) {
      const acc = document.querySelector('[data-pdp-guide]');
      if (acc) {
        acc.open = true;
        acc.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      return;
    }

    // detail page: add to baggie
    const pdpAdd = e.target.closest('.pdp__add');
    if (pdpAdd) {
      const scope = document.querySelector('[data-pdp-info]');
      const picked = scope.querySelector('.size-chip[aria-pressed="true"]');
      const hint = scope.querySelector('.size-hint');
      if (!picked) {
        if (hint) { hint.textContent = 'Pick a size first.'; hint.classList.add('is-error'); }
        const row = scope.querySelector('.size-row');
        if (row) { row.classList.remove('shake'); void row.offsetWidth; row.classList.add('shake'); }
        const first = scope.querySelector('.size-chip');
        if (first) first.focus();
        return;
      }
      const id = new URLSearchParams(location.search).get('id');
      const size = picked.dataset.size;
      const p = byId(id);
      addToBag(id, size, pdpColor, pdpQty);
      const shown = p.colors.length > 1 ? `${pdpColor}, ${size}` : size;
      toast(`${p.title} (${shown}${pdpQty > 1 ? ` × ${pdpQty}` : ''}) added to your baggie`);
      // the detail page is high intent — put checkout one tap away rather than
      // making them go hunting for the bag. Grid cards stay toast-only so
      // browsing is not interrupted.
      openBag();
      return;
    }

    // add to baggie
    const add = e.target.closest('.card__add');
    if (add) {
      const card = add.closest('.card');
      const picked = card.querySelector('.size-chip[aria-pressed="true"]');
      const hint = card.querySelector('.size-hint');
      if (!picked) {
        if (hint) { hint.textContent = 'Pick a size first.'; hint.classList.add('is-error'); }
        const row = card.querySelector('.size-row');
        if (row) { row.classList.remove('shake'); void row.offsetWidth; row.classList.add('shake'); }
        const first = card.querySelector('.size-chip');
        if (first) first.focus();
        return;
      }
      const id = card.dataset.product;
      const size = picked.dataset.size;
      addToBag(id, size, defaultColor(byId(id)));
      toast(`${byId(id).title} (${size}) added to your baggie`);
      return;
    }

    // qty + remove inside drawer
    const act = e.target.closest('[data-act]');
    if (act && act.closest('.bag-line')) {
      const line = act.closest('.bag-line');
      const id = line.dataset.id, size = line.dataset.size, color = line.dataset.color;
      const i = lineIndex(id, size, color);
      if (i < 0) return;
      const a = act.dataset.act;
      if (a === 'inc') setQty(id, size, color, bag[i].qty + 1);
      else if (a === 'dec') setQty(id, size, color, bag[i].qty - 1);
      else if (a === 'remove') setQty(id, size, color, 0);
      return;
    }

    // open / close drawer
    if (e.target.closest('[data-bag-open]')) { e.preventDefault(); openBag(); return; }
    if (e.target.closest('[data-bag-close]') || e.target.closest('[data-bag-backdrop]')) { closeBag(); return; }

    // disabled checkout guard
    const co = e.target.closest('[data-bag-checkout]');
    if (co && co.getAttribute('aria-disabled') === 'true') { e.preventDefault(); }

    // account menu
    const accBtn = e.target.closest('[data-account-toggle]');
    const menu = document.querySelector('[data-account-menu]');
    if (accBtn && menu) {
      e.preventDefault();
      const open = menu.classList.toggle('is-open');
      accBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (menu && menu.classList.contains('is-open') && !e.target.closest('[data-account-menu]')) {
      menu.classList.remove('is-open');
      const b = document.querySelector('[data-account-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const d = drawer();
    if (d && d.classList.contains('is-open')) closeBag();
    const menu = document.querySelector('[data-account-menu]');
    if (menu && menu.classList.contains('is-open')) {
      menu.classList.remove('is-open');
      const b = document.querySelector('[data-account-toggle]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    }
  });

  /* ---- catalog filter (bound after grids render) ---- */
  function applyFilter(f) {
    document.querySelectorAll('.chip[data-filter]').forEach((c) =>
      c.setAttribute('aria-pressed', c.dataset.filter === f ? 'true' : 'false'));
    document.querySelectorAll('[data-category]').forEach((card) => {
      const match =
        f === 'all' ? true :
        f === 'new' ? card.dataset.new === '1' :
        card.dataset.category === f;
      card.style.display = match ? '' : 'none';
    });
  }

  function bindFilters() {
    const chips = document.querySelectorAll('.chip[data-filter]');
    if (!chips.length) return;
    chips.forEach((chip) => {
      chip.addEventListener('click', () => applyFilter(chip.dataset.filter));
    });

    // deep links from the Store dropdown
    const fromHash = () => {
      const h = (location.hash || '').replace('#', '');
      // only "all" remains while the catalog is small — a stale bookmark to
      // #tee would otherwise land on a filtered store with no chip showing it
      if (h === 'all') applyFilter(h);
    };
    fromHash();
    window.addEventListener('hashchange', fromHash);
  }

  /* The Shopify product page's Add button is a real form submit, which would
     navigate away to /cart. With the shared cart it can add in place and open
     the drawer instead, like every other Add on the site. Bound on the
     document rather than the form so it survives the colour script reordering
     the markup, and skipped entirely without JS — the form still posts. */
  if (USE_SHOPIFY_CART) {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form.pdp__form');
      if (!form) return;
      const picked = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      const qtyEl = form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      if (!picked || !picked.value) return;
      e.preventDefault();
      SHOPIFY_CART.add(picked.value, qty).then(refreshFromShopify).then(openBag);
    });
  }

  renderPDP();
  renderGrids();
  bindFilters();
  render();
  renderFavourites();

  // Shopify holds the cart, so the first paint of the drawer is empty until
  // this lands; render() runs again with the real lines.
  if (USE_SHOPIFY_CART) refreshFromShopify();
})();
